import React from 'react'

const ProductSegment = () => {
  return (
    <div>ProductSegment</div>
  )
}

export default ProductSegment